// extracted by mini-css-extract-plugin
export default {"component":"Step__component-j5ja","heading":"Step__heading-gsjM","content":"Step__content-MWUe"};